<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/restauration/amis-montagne.png" bg>
            Les Amis de la Montagne
        </client-card>
        <client-card src="img/clients-color/restauration/am-pm-kosher-market.png" bg>
            AM PM Kosher Market
        </client-card>
        <client-card src="img/clients-color/restauration/arouch.png">
            Arouch
        </client-card>
        <client-card src="img/clients-color/restauration/mc_cafe.png" bg>
            McCafe
        </client-card>
        <client-card src="img/clients-color/restauration/mc_donalds.jpg">
            McDonald's
        </client-card>
        <client-card src="img/clients-color/restauration/mty.png">
            MTY
        </client-card>
        <client-card src="img/clients-color/restauration/cafe_depot.png">
            Café Dépot
        </client-card>
        <client-card src="img/clients-color/restauration/mty-cultures.png" bg>
            Cultures
        </client-card>
        <client-card src="img/clients-color/restauration/client_coq_frit.jpg">
            Le Coq Frit
        </client-card>
        <client-card src="img/clients-color/restauration/voie-maltee-quebec.png" bg>
            La Voie Maltée
        </client-card>
        <client-card src="img/clients-color/restauration/double_pizza.png">
            Double Pizza
        </client-card>
        <client-card src="img/clients-color/restauration/dunkin_donut.png">
            Dunkin Donut
        </client-card>
        <client-card src="img/clients-color/restauration/koryo.png">
            Koryo
        </client-card>
        <client-card src="img/clients-color/restauration/presse_cafe.png">
            Presse Café
        </client-card>
        <client-card src="img/clients-color/restauration/roaster.png">
            Roaster
        </client-card>
        <client-card src="img/clients-color/restauration/solit-cafe.png" bg>
            Solit Café
        </client-card>
        <client-card src="img/clients-color/restauration/subway.png" bg>
            Subway
        </client-card>
        <client-card src="img/clients-color/restauration/tcby.png">
            TCBY
        </client-card>
        <client-card src="img/clients-color/restauration/thai_express.png">
            Thai Express
        </client-card>
        <client-card src="img/clients-color/restauration/van_houtte.png" bg>
            Van Houtte
        </client-card>
        <client-card src="img/clients-color/restauration/villa_madina.png">
            Villa Madina
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `signage-restauration-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Restauration Digital Signage Client|Client restauration affichage numérique`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
